// src/portals/fan/pages/CategoryPage/CategoryPage.js
import React from "react";
import { useParams, Link } from "react-router-dom";
import { featuredCreators } from "../../../../data/mockData";
import PageHeader from "../../components/PageHeader";

// A simple card for the results list
const CreatorResultCard = ({ creator }) => (
  <Link
    to={`/fan/creator/${creator.username}`}
    className="flex items-center p-4 bg-white rounded-xl border border-slate-200"
  >
    <img
      src={creator.profilePictureUrl}
      alt={creator.name}
      className="w-12 h-12 rounded-full object-cover mr-4"
    />
    <div className="flex-grow">
      <p className="font-semibold text-slate-800">{creator.name}</p>
      <p className="text-sm text-slate-500">@{creator.username}</p>
    </div>
  </Link>
);

const CategoryPage = () => {
  const { categoryName } = useParams();
  const filteredCreators = featuredCreators.filter(
    (creator) => creator.category.toLowerCase() === categoryName.toLowerCase()
  );

  return (
    <div className="flex flex-col h-full bg-slate-50">
      <PageHeader title={categoryName} backTo="/fan" />
      <div className="flex-grow overflow-y-auto p-4 space-y-3">
        {filteredCreators.length > 0 ? (
          filteredCreators.map((creator) => (
            <CreatorResultCard key={creator.id} creator={creator} />
          ))
        ) : (
          <p className="text-center text-slate-500 pt-16">
            No creators found in this category.
          </p>
        )}
      </div>
    </div>
  );
};

export default CategoryPage;
